// extracted by mini-css-extract-plugin
module.exports = {"subprofilesContainer":"SubprofilesContainer_subprofilesContainer__yZUGw","logoContainer":"SubprofilesContainer_logoContainer__534uL","close":"SubprofilesContainer_close__CVcgX"};